import React, { createContext, useState, useContext } from 'react';

type PasswordValues = {
  password: string;
  passwordConfirmation: string;
}

type Alert = {
  open: boolean;
  messages: string[];
}

type FlatRateContextType = {
  passwordValues: PasswordValues;
  setPasswordValues: (value: PasswordValues | ((prevState: PasswordValues) => PasswordValues)) => void;
  alert: Alert;
  setAlert: (value: Alert | ((prevState: Alert) => Alert)) => void;
};

const FlatRateContext = createContext<FlatRateContextType | undefined>(undefined);

const FlatRateProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  
  const [passwordValues, setPasswordValues] = useState<PasswordValues>({
    password: "",
    passwordConfirmation: ""
  });

  const [alert, setAlert] = useState<Alert>({
    open: false,
    messages: [],
  })

  const value = { passwordValues, setPasswordValues, alert, setAlert };
  return (
    <FlatRateContext.Provider value={value}>
      {children}
    </FlatRateContext.Provider>
  );
};

const useFlatRateContext = () => {
  const context = useContext(FlatRateContext);
  if (!context) {
    throw new Error('useFlatRateContext must be used within an FlatRateProvider');
  }
  return context;
};

export { FlatRateProvider, useFlatRateContext };
